var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/stock-analysis.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-cb6205a8!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/stock-analysis.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/StockAnalysis.vue
// module id = 721
// module chunks = 1